((scope) => {
  const money = value => Number.isSafeInteger(value) && value >= 0;
  function offer({eligibleSubtotal, threshold = 30000, choices = [], selected = null, active = false, verified = false, invalidated = false}) {
    if (!active || !verified) return {state:'inactive'};
    if (!money(eligibleSubtotal) || !money(threshold) || threshold === 0) return {state:'unavailable'};
    const available = choices.filter(item => item.available && item.id && item.label);
    const remaining = Math.max(0, threshold - eligibleSubtotal);
    const progress = Math.min(eligibleSubtotal, threshold);
    if (invalidated) return {state:'invalidated',remaining,progress,threshold,choices:available};
    if (selected && (remaining || !available.some(item => item.id === selected))) return {state:'invalidated',remaining,progress,threshold,choices:available};
    if (!available.length) return {state:'unavailable'};
    if (remaining) return {state:'progress',remaining,progress,threshold,choices:available};
    return {state:selected ? 'selected' : 'eligible',selected,remaining:0,progress,threshold,choices:available};
  }
  function flow(adapter, onChange) {
    let pending = false;
    return {
      async choose(id) {
        if (pending) return;
        pending = true;
        try {
          // The adapter confirms price, availability and selection before rendering success.
          const result = await adapter.choose(id);
          onChange(result);
          return result;
        } finally { pending = false; }
      }
    };
  }
  const api = {offer,flow};
  if (typeof module !== 'undefined') module.exports = api; else scope.petgrafGiftModel = api;
})(globalThis);
